export { default as updateImage } from "./updateImage";
